import { IUserCredentials } from "core/interfaces/user-credentials.interface";

export type ICreateNewPasswordCredentials = IUserCredentials;

export const defaultCreateNewPasswordValues: ICreateNewPasswordCredentials = {
    email: "",
    password: "",
    confirm_password: "",
}
